import { useCallback } from "react";

import cache from "@cache/cache";
import usePusher from "@components/use-pusher/use-pusher";

export default function PusherComplianceProgramReminderSent({
  channelName,
}: {
  channelName: string;
}) {
  const handleUpdateReminderSentDatetime = useCallback(
    ({
      reminder_id,
      sent_datetime,
    }: {
      reminder_id: number;
      sent_datetime: string | null;
    }) => {
      const cacheId = cache.identify({
        __typename: "ComplianceProgramScheduledReminderNode",
        id: reminder_id,
      });
      if (cacheId) {
        cache.modify({
          id: cacheId,
          fields: {
            sentDatetime: () => sent_datetime ?? null,
          },
        });
      }
    },
    [],
  );

  usePusher(
    channelName,
    "compliance_program_reminder_sent",
    handleUpdateReminderSentDatetime,
  );

  return null;
}
